import React from 'react';
import {SelectWrapper} from './type/SelectStructure';
import {FormikSelect} from './type/none-async-select/FormikSelect';
import {RawSelect} from './type/none-async-select/RawSelect';

const rootElement = document.getElementById('root');

const defaultMenuProps = {
    menuPortalTarget: rootElement,
    menuPosition: 'fixed',
    maxMenuHeight: 300,
};
function Select({raw, unsetPortal, menuHeight, ...props}) {
    const menuProps = unsetPortal
        ? {}
        : {...defaultMenuProps, maxMenuHeight: menuHeight || defaultMenuProps.maxMenuHeight};

    if (raw) {
        return (
            <RawSelect
                {...props}
                {...menuProps}
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                        position: 'absolute',
                        overflow: 'scroll',
                        marginTop: '1px',
                        height: 'auto',
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        );
    } else {
        return (
            <FormikSelect
                {...props}
                {...menuProps}
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                        position: 'absolute',
                        overflow: 'scroll',
                        marginTop: '1px',
                        height: 'auto',
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        );
    }
}

Select.Wrapper = SelectWrapper;
export {SelectWrapper, Select};
